import React from "react";
import { Input } from "../ui/input";
import AddressAutocomplete from "./AddressAutocomplete";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const EMPTY_PROPERTY = { address: "", property_type: "", bedrooms: "", beds: "", surface: "", start_date: "", situation: "", listing_url: "", access_info: "", floor: "", building_code: "", elevator: false, equipment: [] };
const KINDS = ["Studio", "Appartement", "Maison", "Villa"];
const SITUATIONS = [["jamais", "Jamais loué"], ["moi", "Déjà loué par moi-même"], ["conciergerie", "Déjà loué avec une autre conciergerie"]];
const box = "h-14 rounded-2xl text-base";

export const toPayload = (p) => ({
  ...p,
  bedrooms: p.bedrooms === "" ? null : Number(p.bedrooms),
  beds: p.beds === "" ? null : Number(p.beds),
  surface: p.surface === "" ? null : Number(p.surface),
});

export default function PropertyFields({ value, onChange, required, onPick, building }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const num = (k, label) => (
    <label className="block">
      <span className="block text-sm font-semibold text-[#5a6158] mb-1 ml-1">{label}</span>
      <Input type="number" min="0" inputMode="numeric" value={value[k]} onChange={(e) => set(k, e.target.value)} placeholder="—" className={box} data-testid={`prop-${k}`} />
    </label>
  );
  return (
    <div className="space-y-3" data-testid="property-fields">
      <AddressAutocomplete value={value.address} onChange={(v) => set("address", v)} onPick={onPick} placeholder={`Adresse du logement${required ? " *" : ""} : commencez à taper…`} className={box} />
      <div className="grid sm:grid-cols-2 gap-3">
        <Select value={value.property_type} onValueChange={(v) => set("property_type", v)}>
          <SelectTrigger className={box} data-testid="prop-type"><SelectValue placeholder="Type de bien" /></SelectTrigger>
          <SelectContent>{KINDS.map((k) => <SelectItem key={k} value={k}>{k}</SelectItem>)}</SelectContent>
        </Select>
        <Select value={value.situation} onValueChange={(v) => set("situation", v)}>
          <SelectTrigger className={box} data-testid="prop-situation"><SelectValue placeholder="Situation actuelle" /></SelectTrigger>
          <SelectContent>{SITUATIONS.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="grid grid-cols-3 gap-3">{num("bedrooms", "Chambres")}{num("beds", "Couchages")}{num("surface", "Surface m²")}</div>
      {building && ["Studio", "Appartement"].includes(value.property_type) && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 items-end" data-testid="prop-building">
          <Input value={value.floor} onChange={(e) => set("floor", e.target.value)} placeholder="Étage" className={box} data-testid="prop-floor" />
          <Input value={value.building_code} onChange={(e) => set("building_code", e.target.value)} placeholder="Code de l'immeuble" className={box} data-testid="prop-building-code" />
          <label className="col-span-2 sm:col-span-1 flex items-center gap-2 h-14 text-sm font-semibold text-[#2c3a31] cursor-pointer"><input type="checkbox" checked={value.elevator} onChange={(e) => set("elevator", e.target.checked)} className="w-4 h-4 accent-[#13261c]" data-testid="prop-elevator" />Ascenseur</label>
        </div>
      )}
      <div className="grid sm:grid-cols-2 gap-3">
        <label className="block">
          <span className="block text-sm font-semibold text-[#5a6158] mb-1 ml-1">Démarrage souhaité des locations</span>
          <Input type="date" value={value.start_date} onChange={(e) => set("start_date", e.target.value)} className={box} data-testid="prop-start" />
        </label>
        <label className="block">
          <span className="block text-sm font-semibold text-[#5a6158] mb-1 ml-1">Annonce existante (facultatif)</span>
          <Input type="url" value={value.listing_url} onChange={(e) => set("listing_url", e.target.value)} placeholder="https://www.airbnb.fr/rooms/…" className={box} data-testid="prop-listing" />
        </label>
      </div>
      <Textarea value={value.access_info} onChange={(e) => set("access_info", e.target.value)} placeholder={required ? "Infos pratiques pour la visite : digicode, étage, parking… (facultatif)" : "Infos utiles sur le logement (facultatif)"} className="min-h-[90px] rounded-2xl text-base" data-testid="prop-access" />
    </div>
  );
}
